// Property-condition factor table — rules/FACTOR_TABLES_MVP.md §5.
//
// The factor depends on the property-condition group (from
// building-type-tables.ts) crossed with the actual property condition
// declared on a BuildingItem.

import type {
  PropertyCondition,
  PropertyConditionGroup,
} from "../types/enums.js";

export const PROPERTY_CONDITION_TABLE: Readonly<
  Record<PropertyConditionGroup, Readonly<Record<PropertyCondition, number>>>
> = {
  type1: {
    不得转让: 1,
    限整体转让: 1.5,
    允许分割转让: 5,
  },
  type2: {
    不得转让: 1,
    限整体转让: 1.4,
    允许分割转让: 2.5,
  },
  type3: {
    不得转让: 0.3,
    限整体转让: 0.8,
    允许分割转让: 1,
  },
  type4to9: {
    不得转让: 0.6,
    限整体转让: 0.8,
    允许分割转让: 1,
  },
  type10: {
    不得转让: 0.8,
    限整体转让: 1,
    允许分割转让: 1,
  },
  type11to15: {
    不得转让: 1,
    限整体转让: 1.3,
    允许分割转让: 1.7,
  },
};
